import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractFormDetalleTicket, ResumenLinea } from '../abstract-form-detalle-ticket';
import { PrintPagoHelper, TipoPago } from '../../../models/printPagoHelper';

@Component({
  selector: 'app-detalle-ticket',
  templateUrl: './detalle-ticket.component.html',
  styleUrls: ['./detalle-ticket.component.scss']
})
export class DetalleTicketComponent extends AbstractFormDetalleTicket {

  @Input() esEditable: boolean;
  @Output() modificarCobro = new EventEmitter<number>();

  public descuentos: ResumenLinea[];
  // vista impresion pago
  public isModalPrintPagoOpen: boolean;
  public printPagoHelper: PrintPagoHelper;

  protected configurarComponenteEspecifico(): void {
    this.descuentos = this.resumenDescuentos;
  }

  onModificarCita(): void {
    this.modificarCita.emit(this.cita);
  }

  openPrintPagoModal() {
    this.isModalPrintPagoOpen = true;
    const helper = PrintPagoHelper.desdePago(this.ticket, TipoPago.Ticket, null);
    this.printPagoHelper = helper;
  }

  closePrintPagoModal() {
    this.isModalPrintPagoOpen = false;
    this.printPagoHelper = null;
  }

}
